import { FunctionComponent } from 'react';
import { MarkerIcon } from '../../Icons/MarkerIcon';
import { Tooltip } from '../../Tooltip';
import { useLocations } from '../../../hooks/useLocations';
import styles from '../styles.module.scss';
import { PublicCourse } from '@cademy-package/sdk-component-types';

const InternationallyHighlight: FunctionComponent = () => {
    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <MarkerIcon />
            </span>
            <p>UK & International Requests Considered</p>
        </li>
    );
};

const UKWideHighlight: FunctionComponent = () => {
    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <MarkerIcon />
            </span>
            <p>UK Wide</p>
        </li>
    );
};

const EducatorLocationsHighlight: FunctionComponent<{ locationIds: Array<string> }> = ({
    locationIds,
}) => {
    const { data: locations } = useLocations(locationIds);

    const locationText = (() => {
        if (!locations) {
            return null;
        }
        if (locations.length === 1) {
            return `${locations[0].city}`;
        }
        if (locations.length === 2) {
            return `${locations[0].city} or ${locations[1].city}`;
        }
        return `${locations[0].city} and ${locations.length - 1} more`;
    })();

    const tooltipText = (() => {
        if (!locations) {
            return '';
        }
        const firstLocationsCities = locations
            .slice(0, locations.length - 1)
            .map((location) => location.city);
        const lastLocationCity = locations[locations.length - 1].city;
        return `${firstLocationsCities.join(', ')}, and ${lastLocationCity}`;
    })();

    if (!locationText) {
        return null;
    }

    if (locations && locations.length > 3) {
        return (
            <li className={styles.highlight}>
                <span className={styles.icon}>
                    <MarkerIcon />
                </span>
                <Tooltip tooltip={tooltipText}>
                    <p>{locationText}</p>
                </Tooltip>
            </li>
        );
    }

    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <MarkerIcon />
            </span>
            <p>{locationText}</p>
        </li>
    );
};

export const LocationHighlight: FunctionComponent<{ course: PublicCourse }> = ({ course }) => {
    if (course.type !== 'on-request') {
        return null;
    }
    if (!course.available_for_in_person_delivery) {
        return null;
    }
    if (course.student_travel_settings.enabled) {
        return (
            <EducatorLocationsHighlight locationIds={course.student_travel_settings.locations} />
        );
    }
    if (course.educator_travel_settings.enabled) {
        if (course.educator_travel_settings.type === 'Internationally') {
            return <InternationallyHighlight />;
        }
        if (course.educator_travel_settings.type === 'UK Wide') {
            return <UKWideHighlight />;
        }
    }
    return null;
};
